import React from 'react';

interface PillBtnProps {
  active: boolean;
  amber?: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

const PillBtn: React.FC<PillBtnProps> = ({ active, amber, onClick, children }) => (
  <button
    onClick={onClick}
    style={{
      padding: '6px 16px',
      borderRadius: 100,
      border: '1px solid',
      fontSize: 13,
      fontFamily: 'var(--sans)',
      fontWeight: 500,
      cursor: 'pointer',
      transition: 'all 0.15s',
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
      background: active ? (amber ? 'var(--amber)' : 'var(--teal-solid)') : 'var(--glass-bg)',
      color: active ? '#0d1117' : 'var(--text2)',
      borderColor: active ? (amber ? 'var(--amber)' : 'var(--teal)') : 'var(--glass-border)',
    }}
  >
    {children}
  </button>
);

export default PillBtn;
